import { ProductStatus } from '../../../../../shared/enums/product-status.enum';
import { BaseModel } from '../../../../../core/_base/crud';
export class ThanhPhamModel extends BaseModel {
        Id_HH: number
        Id_NhomHH: number
        MaHH: string
        TenHH: string
        TenNhomHH: string
        GhiChu: string
        Disable: boolean
        TenNguoiTao: string
        NguoiTao: number
        NgayTao: string
        NguoiSua: number
        NgaySua: string
        TonKhoToiThieu: string
        DungSaiChoPhepNhap: string
        QuyChuan: string
        CanTren: string
        CanDuoi: string
        QuyCachDongGoi: string
        DieuKienBaoQuan: string
        TonKhoToiDa: string
        DVT1: number
        DVT2: number
        DVT3: number
        QuyDoiDVT2: string
        QuyDoiDVT3: string
        HinhDaiDien: string
        BoPhanKiemTra: number
        TenBoPhanKiemTra: string
        BoPhanGiamSat: number
        TenBoPhanGiamSat: string
        ThoiHanSuDung: number
        domain: string
        listKH: any[]
        listNCC: any[]
        listLinkImage: ListImageModel[]
        CanPhieuKt: boolean
        Id_LHH: string
        KhoMacDinh: string
        DongSanPham: number
        PhanTramThueVAT: number
        TenFileGoc: string
        FileImport: FileImportHH
        fileTmpDownLoad: any
        File_TieuChuan: number
        BCSX_WarningRange: string
        DVTThongKeTon:number
        Status: number
        clear() {
                this.Id_HH = 0;
                this.Id_NhomHH = 0;
                this.MaHH = '';
                this.TenHH = '';
                this.TenNhomHH = '';
                this.GhiChu = '';
                this.Disable = false;
                this.TenNguoiTao = '';
                this.NguoiTao = 0;
                this.NgayTao = '';
                this.NguoiSua = 0;
                this.NgaySua = '';
                this.TonKhoToiThieu = '0.00';
                this.DungSaiChoPhepNhap = '0.00';
                this.QuyChuan = '';
                this.CanTren = '';
                this.CanDuoi = '';
                this.QuyCachDongGoi = '';
                this.DieuKienBaoQuan = '';
                this.TonKhoToiDa = '0.00';
                this.DVT1 = 0;
                this.DVT2 = 0;
                this.DVT3 = 0;
                this.QuyDoiDVT2 = '0.000000';
                this.QuyDoiDVT3 = '0.000000';
                this.ThoiHanSuDung = 0;
                this.HinhDaiDien = '';
                this.BoPhanKiemTra = 0;
                this.TenBoPhanKiemTra = '';
                this.BoPhanGiamSat = 0;
                this.TenBoPhanGiamSat = '';
                this.domain = '';
                this.listLinkImage = [];
                this.listNCC = [];
                this.listKH = [];
                this.CanPhieuKt = false;
                this.Id_LHH = '';
                this.KhoMacDinh = '';
                this.DongSanPham = 0;
                this.PhanTramThueVAT = 0;
                this.TenFileGoc = '';
                this.FileImport = new FileImportHH();
                this.File_TieuChuan = 0;
                this.BCSX_WarningRange = '0.00';
                this.DVTThongKeTon = 0;
                this.Status = ProductStatus.Active;
        }
        copy(item: ThanhPhamModel) {
                this.Id_HH = item.Id_HH;
                this.Id_NhomHH = item.Id_NhomHH;
                this.MaHH = item.MaHH;
                this.TenHH = item.TenHH;
                this.TenNhomHH = item.TenNhomHH;
                this.GhiChu = item.GhiChu;
                this.Disable = item.Disable;
                this.TenNguoiTao = item.TenNguoiTao;
                this.NguoiTao = item.NguoiTao;
                this.NgayTao = item.NgayTao;
                this.NguoiSua = item.NguoiSua;
                this.NgaySua = item.NgaySua;
                this.TonKhoToiThieu = item.TonKhoToiThieu;
                this.DungSaiChoPhepNhap = item.DungSaiChoPhepNhap;
                this.QuyChuan = item.QuyChuan;
                this.CanTren = item.CanTren;
                this.CanDuoi = item.CanDuoi;
                this.QuyCachDongGoi = item.QuyCachDongGoi;
                this.DieuKienBaoQuan = item.DieuKienBaoQuan;
                this.TonKhoToiDa = item.TonKhoToiDa;
                this.DVT1 = item.DVT1;
                this.DVT2 = item.DVT2;
                this.DVT3 = item.DVT3;
                this.ThoiHanSuDung = item.ThoiHanSuDung;
                this.QuyDoiDVT2 = item.QuyDoiDVT2;
                this.QuyDoiDVT3 = item.QuyDoiDVT3;
                this.HinhDaiDien = item.HinhDaiDien;
                this.BoPhanKiemTra = item.BoPhanKiemTra;
                this.TenBoPhanKiemTra = item.TenBoPhanKiemTra;
                this.BoPhanGiamSat = item.BoPhanGiamSat;
                this.TenBoPhanGiamSat = item.TenBoPhanGiamSat
                this.domain = item.domain;
                this.listLinkImage = item.listLinkImage;
                this.listNCC = item.listNCC;
                this.listKH = item.listKH;
                this.CanPhieuKt = item.CanPhieuKt;
                this.Id_LHH = item.Id_LHH;
                this.KhoMacDinh = item.KhoMacDinh;
                this.DongSanPham = item.DongSanPham;
                this.PhanTramThueVAT = item.PhanTramThueVAT;
                this.TenFileGoc = item.TenFileGoc;
                this.File_TieuChuan = item.File_TieuChuan;
                if (item.FileImport != null) {
                        this.FileImport = new FileImportHH();
                        this.FileImport.copy(item.FileImport);
                }
                else {
                        this.FileImport = new FileImportHH();
                        this.FileImport.clear();
                }
                this.BCSX_WarningRange = item.BCSX_WarningRange;
                this.Status = item.Status;
        }
}
export class ListImageModel extends BaseModel {
        strBase64: string
        filename: string
        src: string
        IsAdd: boolean
        IsDel: boolean
        IsImagePresent: boolean
        clear() {
                this.strBase64 = '';
                this.filename = '';
                this.src = '';
                this.IsAdd = false;
                this.IsDel = false;
                this.IsImagePresent = false;
        }
        copy(item: ListImageModel) {
                this.strBase64 = item.strBase64;
                this.filename = item.filename;
                this.src = item.src;
                this.IsAdd = item.IsAdd;
                this.IsDel = item.IsDel;
                this.IsImagePresent = item.IsImagePresent;
        }
}
export class FileImportHH extends BaseModel {
        idLoaiHH: number;
        base64: string;
        fileByte: any;
        filename: string;
        dienGiai: string;
        extension: string;

        clear() {
                this.idLoaiHH = 0;
                this.base64 = '';
                this.fileByte = null;
                this.filename = '';
                this.dienGiai = '';
                this.extension = '';
        }

        copy(item: FileImportHH) {
                this.idLoaiHH = item.idLoaiHH;
                this.base64 = item.base64;
                this.fileByte = item.fileByte;
                this.filename = item.filename;
                this.dienGiai = item.dienGiai;
                this.extension = item.extension;
        }
}